import { Divider, Grid, TablePagination } from "@mui/material";
import TablePaginationActions from "../../shared/components/Table/Actions";
import PixTransacaoViewV2 from "./PixTransacaoViewV2";

const formatDisplayedRows = ({ from, to, count }) => {
  const total = count !== -1 ? `${count} registros` : `mais de ${to}`;
  return `${from}-${to} de ${total}`;
};

const PixTransacaoPageV2 = ({ pixTransacaoPage, handleChangePage }) => {
  const { content, size, totalElements, number } = pixTransacaoPage;

  return (
    <Grid container spacing={3}>
      <Grid size={12}>
        <TablePagination
          component="div"
          rowsPerPageOptions={[]}
          rowsPerPage={size ?? 0}
          count={totalElements}
          page={number}
          onPageChange={handleChangePage}
          labelDisplayedRows={formatDisplayedRows}
          ActionsComponent={TablePaginationActions}
        />
      </Grid>
      {content.map((pixTransacao, index) => (
        <Grid key={pixTransacao.id ?? index} size={12}>
          <PixTransacaoViewV2 pixTransacao={pixTransacao} />
          {index < content.length - 1 && <Divider sx={{ mt: 3 }} />}
        </Grid>
      ))}

      <Grid size={12}>
        <TablePagination
          component="div"
          rowsPerPageOptions={[]}
          rowsPerPage={size ?? 0}
          count={totalElements}
          page={number}
          onPageChange={handleChangePage}
          labelDisplayedRows={formatDisplayedRows}
          ActionsComponent={TablePaginationActions}
        />
      </Grid>
    </Grid>
  );
};

export default PixTransacaoPageV2;
